import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const usePaymentTerms = () => {
    return useQuery({
        queryKey: ["paymentTerms"],
        queryFn: () => CommonService.getPaymentTerms().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};